import { useMutation } from "@tanstack/react-query"
import { apiService } from "@/lib/api"
import { JobAlertFormData } from "@/utils/helpers/validators/jobAlert/jobAlert.schema"

export function useJobsAlert() {
   const createJobsAlertMutation = useMutation({
      mutationKey: ["jobsAlertForm"],
      meta: {
         suppressGlobalToast: true,
      },
      mutationFn: async (payload: JobAlertFormData) => {
         return apiService.post("/api/job-alert", payload)
      },

      onSuccess: (_response, variables) => {
         console.log("✅ Jobs Alert sent via proxy", { payload: variables, _response })
      },

      onError: (error: Error, variables) => {
         console.error("❌ Jobs Alert proxy failed", { error, payload: variables })
      },
   })

   return {
      createJobsAlertMutation,
   }
}